import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';

import { AccountDetailsPageRoutingModule } from './account-details-rountng.module';

import { AccountDetailsPage } from './account-details.page';
import { MasterHeaderModule } from '../master-header/master-header.module';
import { MasterFooterModule } from '../master-footer/master-footer.module';
import { PaymentPlanOptionComponent } from './payment-plan-option/payment-plan-option.component';
import { CommunicationPreferencesComponent } from './communication-preferences/communication-preferences.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    AccountDetailsPageRoutingModule,
    MasterHeaderModule,
    MasterFooterModule,
    ReactiveFormsModule,
    TranslateModule
  ],
  declarations: [AccountDetailsPage, PaymentPlanOptionComponent, CommunicationPreferencesComponent],
})
export class AccountDetailsPageModule {}
